import * as React from "react";
import { forwardRef } from "react";
const SvgIconHome = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 9H3V16H5V9ZM11 9H9V16H11V9ZM19.5 18H0.5V20H19.5V18ZM17 9H15V16H17V9ZM10 2.26L15.21 5H4.79L10 2.26ZM10 0L0.5 5V7H19.5V5L10 0Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIconHome);
export { ForwardRef as ReactComponent };
